export default __webpack_public_path__ + "static/media/6.e35697a4.png";